<template>
  <div class="track-container">
    <template v-for="(group, indexGroup) in itemsFormat">
      <track-item
        :key="indexGroup"
        :month="group.month"
        :year="group.year"
        :tracks="group.data"
        :opportunity="opportunity"
        :is-final="indexGroup + 1 === itemsFormat.length "
        class="track-block"
        @checkComplete="checkComplete"
        @editTrack="editTrack"/>
    </template>
  </div>
</template>

<script>
/**
*
* TrackContainer Component
*
* @author Emmanuel Hernández
* @copyright 2019, Marciano Studio S.C.
*/
import TrackItem from './track-item'
import moment from 'moment'
export default {
  name: 'TrackContainer',
  components: { TrackItem },
  props: {
    trackings: {
      type: Array,
      default: () => {
        return []
      }
    },
    opportunity: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    itemsFormat () {
      let tempArray = []
      if (this.trackings.length > 0) {
        let trackings = this.trackings.slice()
        trackings.sort(this.sortDate)
        let reverse = trackings.slice().reverse()
        let found = reverse.find((el, index) => {
          return el.status === 'Rechazada' || el.status === 'Aceptada'
        })
        let indexFound = trackings.indexOf(found)
        let find = false
        for (let i = 0; i < trackings.length; i++) {
          find = false
          let item = trackings[i]
          if (i > indexFound) {
            item.edit = true
          } else {
            item.edit = false
          }
          let itemYear = item.dueDate ? moment(item.dueDate).format('YYYY') : moment(item.createdAt).format('YYYY')
          let itemMonth = item.dueDate ? moment(item.dueDate).format('MMMM') : moment(item.createdAt).format('MMMM')
          if (tempArray.length > 0) {
            for (let j = 0; j < tempArray.length; j++) {
              const el = tempArray[j]
              if (el.year === itemYear && el.month === itemMonth) {
                tempArray[j].data.push(item)
                find = true
                break
              }
            }
            if (!find) {
              tempArray.push({
                year: itemYear,
                month: itemMonth,
                data: [item]
              })
            }
          } else {
            tempArray.push({
              year: itemYear,
              month: itemMonth,
              data: [item]
            })
          }
        }
      }
      return tempArray
    }
  },
  methods: {
    editTrack (id, final) {
      this.$emit('editTrack', id, final)
    },
    checkComplete (track) {
      this.$emit('checkComplete', track)
    },
    sortDate (a, b) {
      return moment.utc(a.dueDate ? a.dueDate : a.createdAt).diff(moment.utc(b.dueDate ? b.dueDate : b.createdAt))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/trackings/track-container.vue